import { en } from './en'
import { fr } from './fr'

export const common = {
  en,
  fr
}